import React from 'react'
import PropTypes from 'prop-types'

// Decorative inline SVGs: a path in the 14 viewBox, or { viewBox, paths }. The control owns the label.

const PATHS = {
  'chevron-left': 'M9 2.5L4.5 7L9 11.5',
  'chevron-right': 'M5 2.5L9.5 7L5 11.5',
  people: {
    viewBox: '0 0 24 24',
    paths: [
      'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2',
      'M9 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8z',
      'M23 21v-2a4 4 0 0 0-3-3.87',
    ],
  },
  calendar: {
    viewBox: '0 0 24 24',
    paths: [
      'M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
      'M16 2v4',
      'M8 2v4',
      'M3 10h18',
    ],
  },
  search: {
    viewBox: '0 0 24 24',
    paths: [
      'M11 4a7 7 0 1 1 0 14 7 7 0 0 1 0-14z',
      'M21 21l-4.35-4.35',
    ],
  },
}

const DEFAULT_VIEW_BOX = '0 0 14 14'

const Icon = ({ name, size = 14 }) => {
  const entry = PATHS[name]
  if (!entry) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`gl Icon: no path for "${name}" - rendering nothing`)
    }
    return null
  }

  const viewBox = typeof entry === 'string' ? DEFAULT_VIEW_BOX : entry.viewBox
  const paths = typeof entry === 'string' ? [ entry ] : entry.paths

  return (
    <svg width={size} height={size} viewBox={viewBox} fill="none" aria-hidden="true">
      {paths.map((path) => (
        <path
          key={path}
          d={path}
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  )
}

Icon.propTypes = {
  name: PropTypes.oneOf([ 'chevron-left', 'chevron-right', 'people', 'calendar', 'search' ]).isRequired,
  size: PropTypes.number,
}

export default Icon
